import WidgetBaseDetailModel from "./WidgetBaseDetailModel";
import WidgetLanguageDetailModel from "./WidgetLanguageDetailModel";
import { WidgetTypeEnum } from "../../common/enum";
import AudioFileModel from "./AudioFileModel";

export default class SendMessageWidgetModel extends WidgetBaseDetailModel {
	public nextAction: string;
	public messageText: WidgetLanguageDetailModel[];
	public messageAudioFile: AudioFileModel[];

	public constructor() {
		super();
		this.type = WidgetTypeEnum.SendMessage;
		this.nextAction = "";
		this.messageText = [];
		this.messageAudioFile = [];
	}
}
